import { Component, OnInit, OnDestroy, inject, signal } from '@angular/core';
import { ConfigService } from '../../../core/services/autoconfig/config.service';

@Component({
  selector: 'app-error-config',
  imports: [],
  templateUrl: './error-config.component.html',
  styleUrl: './error-config.component.scss',
})
export class ErrorConfigComponent implements OnInit, OnDestroy {
  readonly countdown = signal(15);

  private readonly configService = inject(ConfigService);
  private retryInterval?: ReturnType<typeof setInterval>;
  private countdownInterval?: ReturnType<typeof setInterval>;

  readonly RETRY_INTERVAL = 15_000;

  ngOnInit(): void {
    this.attemptConnection();
    this.retryInterval = setInterval(() => this.attemptConnection(), this.RETRY_INTERVAL);
  }

  ngOnDestroy(): void {
    this.clearIntervals();
  }

  private async attemptConnection(): Promise<void> {
    this.clearCountdown();
    await this.configService.loadConfig();
    if (!this.configService.errorLoading()) {
      this.clearIntervals();
      location.reload();
    } else {
      this.startCountdown();
    }
  }

  private startCountdown(): void {
    this.countdown.set(15);
    this.countdownInterval = setInterval(() => {
      const next = this.countdown() - 1;
      this.countdown.set(next);
      if (next <= 0) this.clearCountdown();
    }, 1000);
  }

  private clearCountdown(): void {
    clearInterval(this.countdownInterval);
    this.countdownInterval = undefined;
  }

  private clearIntervals(): void {
    clearInterval(this.retryInterval);
    this.retryInterval = undefined;
    this.clearCountdown();
  }
}
